module.exports = __webpack_public_path__ + "resources/img/img_security_shellcop_m.d3aeb4d1c5b0e58b7cc43e4e0642812f.png";